export var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["TEXT"] = "text";
    ButtonTypes["CONTAINED"] = "contained";
    ButtonTypes["OUTLINED"] = "outlined";
})(ButtonTypes || (ButtonTypes = {}));
//# sourceMappingURL=ButtonTypes.js.map